var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 363 363",
    style: {
      enableBackground: "new 0 0 363 363"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M343,25.5H20c-11.028,0-20,8.972-20,20v272c0,11.028,8.972,20,20,20h323c11.028,0,20-8.972,20-20v-272   C363,34.472,354.028,25.5,343,25.5z M142,56.5c0-6.05,4.95-11,11-11h56c6.05,0,11,4.95,11,11v8c0,6.05-4.95,11-11,11h-56   c-6.05,0-11-4.95-11-11V56.5z M103,305.5c0,6.05-4.95,11-11,11H39c-6.05,0-11-4.95-11-11v-8c0-6.05,4.95-11,11-11h53   c6.05,0,11,4.95,11,11V305.5z M103,64.5c0,6.05-4.95,11-11,11H39c-6.05,0-11-4.95-11-11v-8c0-6.05,4.95-11,11-11h53   c6.05,0,11,4.95,11,11V64.5z M220,305.5c0,6.05-4.95,11-11,11h-56c-6.05,0-11-4.95-11-11v-8c0-6.05,4.95-11,11-11h56   c6.05,0,11,4.95,11,11V305.5z M185.638,253.464c-39.883,0-72.214-32.331-72.214-72.214s32.331-72.214,72.214-72.214   c39.883,0,72.214,32.331,72.214,72.214S225.521,253.464,185.638,253.464z M336,305.5c0,6.05-4.95,11-11,11h-57   c-6.05,0-11-4.95-11-11v-8c0-6.05,4.95-11,11-11h57c6.05,0,11,4.95,11,11V305.5z M336,64.5c0,6.05-4.95,11-11,11h-57   c-6.05,0-11-4.95-11-11v-8c0-6.05,4.95-11,11-11h57c6.05,0,11,4.95,11,11V64.5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.331,175.572l-60.854-41.893C162.95,130.555,159,132.5,159,138v86.5c0,5.5,3.95,7.445,8.477,4.322l60.793-41.893   C232.797,183.805,232.859,178.695,228.331,175.572z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#D8D7D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieLight);
export default __webpack_public_path__ + "static/media/movie-light.c289cc13b7b5b3fa7151489c61ae3ef9.svg";
export { ForwardRef as ReactComponent };